import SpineSymbol from 'core/display/spines/SpineSymbol'
import Sprite from 'core/display/Sprite'
import { time } from 'settings/custom/win'
import { tint } from 'utils/Tweens'

import { Device } from '../../../../../utils/Device'
import { create, replace } from '../../../../../utils/Object'

export default class SpriteSymbol extends PIXI.Container {
  constructor(id, settings) {
    super()

    this.id = id
    this.settings = settings
    this._sprite = null
    this._scale = Device.isDesktop() ? 1 : 0.5
    this.createBackSpines(id)
    this.createSymbol(id)
    this.createOverLayerSprite(id)
    this.createFrontSpines(id)
  }
  reset(){

  }

  get sprite() {
    return this._sprite
  }

  createSymbol(id) {
    this.createSprite(id)
  }

  createSprite(id) {
    this._sprite = new Sprite({ texture: game.getTextureFromAtlases(id) })
    this._staticTex = game.getTextureFromAtlases(id)
    this._blurTexture = game.getTextureFromAtlases(id + '_blur')
    this._sprite.scale.set(this._scale)
    this.addChild(this._sprite)
  }

  createOverLayerSprite(id) {
    this._spriteOver = new Sprite({ texture: game.getTextureFromAtlases(id) })
    this._spriteOver.scale.set(this._scale)
    this._spriteOver.visible = false
    this.addChild(this._spriteOver)
  }

  swapSpine(visible){
    this._spinesBackSymbol.visible = visible
    this._spinesFrontSymbol.visible = visible
    this._sprite.visible = true
  }

  createBackSpines(id) {
    const { back, items } = this.settings
    if (back) {
      const spine = new SpineSymbol(create(items, replace(back, 'spine', id)))
      spine.scale.set(this._scale)
      spine.visible = true
      this._spinesBackSymbol = spine
      this.addChild(spine)
    }
  }

  createFrontSpines(id) {
    const { front, items } = this.settings
    if (front) {
      const spine = new SpineSymbol(create(items, replace(front, 'spine', id)))
      spine.scale.set(this._scale)
      spine.visible = true
      this._spinesFrontSymbol = spine
      this.addChild(spine)
    }
  }

  playStatic(){
    this.swapSpine(false)
    this._sprite.filters = null
    this._sprite.tint = 0xFFFFFF
    this._sprite.texture = this._staticTex
  }
  playMove(){
    this.swapSpine(false)
    if(this._blurTexture) {
      this._sprite.texture = this._blurTexture
    }
    this._sprite.tint = 0xFFFFFF
  }

  playDim(){
    this.swapSpine(false)
    tint(this._sprite, time).then()

  }
  playIdleAnimation(){
    this.swapSpine(true)
  }

  playSpineFreeSpin(){
    this.swapSpine(true)
  }
  makeWinAnimation() {
    this.swapSpine(true)
    const { front, back } = this.settings
    if(front){
      this._spriteOver.visible = true
      this._spinesBackSymbol.playCallBack('animation', false, () => {
        this._spriteOver.visible = false
        this.swapSpine(false)
      })
    }

    if(back){
      this._spriteOver.visible = true
      this._spinesFrontSymbol.playCallBack('animation', false, () => {
        this._spriteOver.visible = false
        this.swapSpine(false)
      })
    }
  }

}
